// Extension to handle signature block images in Quill editor.
// Stores images as base64 data URIs so they persist across sessions
// without requiring an S3 upload at compose time.
//
// Usage:
//    quill.insertEmbed(index, "signatureImage", { src, signatureImageId })

import Quill from "quill"
const ImageBlot = Quill.import("formats/image")

class SignatureImage extends ImageBlot {
  static blotName = "signatureImage"

  static create(value) {
    let node = super.create(value)
    if (typeof value === "object") {
      node.setAttribute("src", value.src)
      node.dataset.signatureImageId = value.signatureImageId
    }
    return node
  }

  static value(node) {
    return {
      src: node.getAttribute("src"),
      signatureImageId: node.dataset.signatureImageId,
    }
  }
}

Quill.register(SignatureImage)
